import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("bh_cart")) || []; }
    catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("bh_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found)
        return prev.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        product_id: product.id, slug: product.slug, name: product.name,
        price: product.price, qty, image: product.image, ship_fee: product.ship_fee ?? 4.25,
      }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((id, qty) =>
    setItems((prev) => prev.map((i) => i.product_id === id ? { ...i, qty: Math.max(1, qty) } : i)), []);
  const removeItem = useCallback((id) => setItems((prev) => prev.filter((i) => i.product_id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  const value = useMemo(
    () => ({ items, addItem, updateQty, removeItem, clear, count, subtotal, open, setOpen }),
    [items, addItem, updateQty, removeItem, clear, count, subtotal, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
